/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketStatusPaginatedResponseItem } from '../../models/ticket-status-paginated-response-item';

export interface TicketStatusControllerFindAll$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  visible?: boolean;
  visible_from_mobile_app?: boolean;

/**
 * Restituisce solo gli stati applicabili a questo tipo di ticket (oltre a quelli senza alcuna restrizione di tipo).
 */
  ticket_type_id?: number;
  search?: string;
  order_by?: string;
  order_direction?: string;
}

export function ticketStatusControllerFindAll(http: HttpClient, rootUrl: string, params: TicketStatusControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketStatusPaginatedResponseItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketStatusControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('visible', params.visible, {});
    rb.query('visible_from_mobile_app', params.visible_from_mobile_app, {});
    rb.query('ticket_type_id', params.ticket_type_id, {});
    rb.query('search', params.search, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketStatusPaginatedResponseItem;
      }>;
    })
  );
}

ticketStatusControllerFindAll.PATH = '/ticket-status';
